import axios from 'axios';
import React from 'react'
import ENDPOINT from '../../context/EndPoint';
import SecurityHeaders from '../../context/SecurityHeaders';

const AdminDeletePlacementRequest = async ({payload}) => {
    const data = new FormData();

    data.append('id',payload.id);

    const res = await axios.post(ENDPOINT+'admin-delete-placement-request.php',data,SecurityHeaders);
    
    if(res){
        return res.data
    }
}

export default AdminDeletePlacementRequest